import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { URLS, ImgURL } from "../utils/urls";
import { useTopLoader } from "../context/TopLoaderContext";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ firstName: "", lastName: "", password: "" , role: "", profileImage: ""});
  const [preview, setPreview] = useState("");
  const [message, setMessage] = useState("");
  const { start, stop } = useTopLoader();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        start();
        const { data } = await api.get(URLS.ME);
        setProfile(data);
        setForm({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          role: data.role || "",
          password: ""
        });
        setPreview(data.profileImage || "");
      } catch (err) {
        setMessage("Failed to load profile.");
      } finally {
        stop();
      }
    };
    fetchProfile();
  }, []);

  // Handle text input changes
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle profile image upload
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append("profile_image", file);

    try {
      const { data } = await api.post(URLS.UPLOAD_PROFILE_IMAGE, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setPreview(data.profile_image);
      setProfile({ ...profile, profile_image: data.profile_image });
      setMessage("Profile image updated successfully!");
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to upload profile image.");
    }
  };

  // Save profile updates (name + password)
  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put(URLS.ME, form);
      setProfile(data.user);
      setMessage("Profile updated successfully!");
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to update profile.");
    }
  };

  if (!profile) return <div className="p-6">Loading profile...</div>;

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded-lg">
      <h2 className="text-xl font-bold mb-4">My Profile</h2>

      {/* Profile Image Upload */}
      <div className="flex flex-col items-center mb-6">
        <img
          src={preview?.startsWith("blob:") ? preview : (ImgURL(preview) || "https://ui-avatars.com/api/?name=" + profile.firstName + "+" + profile.lastName)}
          alt="Profile"
          className="w-24 h-24 rounded-full object-cover mb-2 border"
        />
        <label className="cursor-pointer bg-gray-100 px-3 py-1 rounded text-sm hover:bg-gray-200">
          Change Photo
          <input type="file" className="hidden" accept="image/*" onChange={handleImageUpload} />
        </label>
      </div>

      <form onSubmit={handleSave} className="space-y-4">
        <div>
          <label className="block text-sm font-medium">First Name</label>
          <input
            type="text"
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Last Name</label>
          <input
            type="text"
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Role: {form.role}</label>
          <input
            type="text"
            name="role"
            value={form.role}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            disabled
            hidden
          />
        </div>


        <div>
          <label className="block text-sm font-medium">New Password</label>
          <input
            type="password"
            name="password"
            placeholder="Leave blank to keep current"
            value={form.password}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <button type="submit" className="bg-[#db8654] hover:bg-[#8C134E] text-white px-4 py-2 rounded">
          Save Changes
        </button>
      </form>

      {message && <p className="mt-4 text-sm text-[#B53B74]">{message}</p>}
    </div>
  );
};

export default Profile;
